import { Component, OnInit } from '@angular/core';
import { CardLgComponent } from '../../../shared/_components/card-lg/card-lg.component';
import { MainPageComponent } from '../../../shared/_components/main-page/main-page.component';
import { Store } from '@ngrx/store';
import { MenuActionsService } from '../../../navigation/_services/menu-actions.service';
import { NavigationActions } from '../../../navigation/_store/navigation.actions';
import { NavigationActionTypes } from '../../../navigation/_models/navigation.models';

@Component({
  selector: 'app-home-dashboard',
  standalone: true,
  imports: [CardLgComponent, MainPageComponent],
  templateUrl: './home-dashboard.component.html',
  styleUrl: './home-dashboard.component.scss'
})
export class HomeDashboardComponent implements OnInit {
  constructor(private store: Store, private menuService: MenuActionsService) {
  }

  ngOnInit(): void {
    this.store.dispatch(NavigationActions.updateMenuNavigation({ menu: this.menuService.populateMenu([NavigationActionTypes.AddTransaction, NavigationActionTypes.ServiceMachine, NavigationActionTypes.ReportIssue]) }));
  }
}
